import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiDeactivateEtcCardRequest,
  DefaultApiGetCurrentEtcCardRequest,
  DefaultApiGetEtcCardsRequest,
  DefaultApiGetEtcCardDetailRequest,
  DefaultApiGetEtcCardTransactionsRequest,
  DefaultApiUpdateEtcCardLabelRequest,
  DefaultApiUpdateEtcCardHolderRequest,
  DefaultApiGetEtcAccountRequest,
  DefaultApiInitiateEtcServiceRequest,
  DefaultApiDownloadEtcAccountingCsvRequest,
  DefaultApiGetEtcAmountsRequest,
} from '@src/api/generated/user-api'

export const getCurrentEtcCard = async (
  instance: AxiosInstance,
  params: DefaultApiGetCurrentEtcCardRequest
) => {
  return await userApiDefaultApiFactory(instance).getCurrentEtcCard(params)
}

export const getEtcCardDetail = async (
  instance: AxiosInstance,
  params: DefaultApiGetEtcCardDetailRequest
) => {
  return await userApiDefaultApiFactory(instance).getEtcCardDetail(params)
}

export const getEtcCardTransactions = async (
  instance: AxiosInstance,
  params: DefaultApiGetEtcCardTransactionsRequest
) => {
  return await userApiDefaultApiFactory(instance).getEtcCardTransactions(params)
}

export const getEtcCards = async (
  instance: AxiosInstance,
  params: DefaultApiGetEtcCardsRequest
) => {
  return await userApiDefaultApiFactory(instance).getEtcCards(params)
}

export const updateEtcCardLabel = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateEtcCardLabelRequest
) => {
  return await userApiDefaultApiFactory(instance).updateEtcCardLabel(params)
}

export const updateEtcCardHolder = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateEtcCardHolderRequest
) => {
  return await userApiDefaultApiFactory(instance).updateEtcCardHolder(params)
}

export const deactivateEtcCard = async (
  instance: AxiosInstance,
  params: DefaultApiDeactivateEtcCardRequest
) => {
  return await userApiDefaultApiFactory(instance).deactivateEtcCard(params)
}

export const getEtcAccount = async (
  instance: AxiosInstance,
  params: DefaultApiGetEtcAccountRequest
) => {
  return await userApiDefaultApiFactory(instance).getEtcAccount(params)
}

export const initiateEtcService = async (
  instance: AxiosInstance,
  params: DefaultApiInitiateEtcServiceRequest
) => {
  return await userApiDefaultApiFactory(instance).initiateEtcService(params)
}

export const downloadEtcAccountingCsv = async (
  instance: AxiosInstance,
  params: DefaultApiDownloadEtcAccountingCsvRequest
) => {
  return await userApiDefaultApiFactory(instance).downloadEtcAccountingCsv(
    params,
    {
      responseType: 'blob',
    }
  )
}

export const getEtcAmounts = async (
  instance: AxiosInstance,
  params: DefaultApiGetEtcAmountsRequest
) => {
  return await userApiDefaultApiFactory(instance).getEtcAmounts(params)
}
